// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './style/style.scss'
import VueCookie from 'vue-cookies'
import iView from 'iview';
import '../node_modules/iview/dist/styles/iview.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'babel-polyfill'
import DebugLogger from './util/logger'

import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/gear'
import 'vue-awesome/icons/sort'

import promise from 'es6-promise';

import axios from 'axios'


import locale from 'iview/dist/locale/ko-KR';

promise.polyfill();
Vue.use(VueCookie)
Vue.use(DebugLogger);
// Vue.use(iView);
Vue.use(iView, { locale });

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


Array.prototype.contains = function ( needle ) {
  for (var i=0;i<this.length;i++) {
    if (this[i] == needle)
      return true;
  }
  return false;
}
axios.defaults.withCredentials=true;

axios.interceptors.request.use( 
  config => { 
      var token = sessionStorage.getItem('token')
      if(token != null){ 
          config.headers['token'] = token 
      } 
      if(config.method=='post'){ 
          config.data = { 
              ...config.data, 
          } 
      }else if(config.method=='get'){ 
          config.params = { 
              ...config.params 
          } 
      } 
      return config 
  },function(error){ 
      return Promise.reject(error) 
  } 
) 

//设置全局的请求返回结果处理，如果返回的是401.则根据自动跳转到登陆界面
axios.interceptors.response.use(
  response => {
    // console.log(response)
    // if(response.data.resultCode == -1){
    //   localStorage.removeItem('user');
    //   router.push('/login')
    //   // return
    // }
         
    // Indicator.close()
    return response;
  },
  error => {
    // console.log(error.response)
    // Indicator.close()
    if (error.response) {
      var response = error.response
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('user');
          sessionStorage.setItem('islogin', false) 
          router.push('/login')
          // console.log(router)
          // router.push('delivery')
          break
        default:
          if (response.data.unknownError){
            Toast('系统好像开小差了呃')
          } else {
            Toast(response.data.errorMsg + '<' + response.data.resCode + '>')
          }
          break
      }
    }
    return Promise.reject(error)
  }
);
// // 增加登陆验证，如果没有token的话就意味着没有登陆，就跳转到登陆界面
// router.beforeEach((to, from, next) => {
//   // 这里的meta就是我们刚刚在路由里面配置的meta
//   if (to.meta.requireAuth == null || to.meta.requireAuth == true) {
//     // 下面这个判断是自行实现到底是否有没有登录
//     var accessToken = localStorage.getItem("accessToken");
//     if (accessToken != null && accessToken != "") {
//       // 登录就继续
//       next();
//     } else {
//       // 没有登录跳转到登录页面，登录成功之后再返回到之前请求的页面
//       next({
//         path: '/login',
//         query: {redirect: to.fullPath}
//       })
//     }
//   } else {
//     // 不需要登录的，可以继续访问
//     next()
//   }
// });


// WEBPACK FOOTER //
// ./src/main.js